import { render, staticRenderFns } from "./AamsDocumentRegCancelApproval.vue?vue&type=template&id=6235db9f&scoped=true&"
import script from "./AamsDocumentRegCancelApproval.vue?vue&type=script&lang=js&"
export * from "./AamsDocumentRegCancelApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235db9f",
  null
  
)

export default component.exports